export default __webpack_public_path__ + "static/media/boat.f104012a.png";